<template>
  <div class="modal-form card">

    <div class="flex justify-between items-center bb b--near-white pb2">
      <h1 class="lh-title text-primary f6 ma0 pa0 ttu">Параметры позиции</h1>
      <button class="input-icon-button bg-light ml3" @click="$emit('canceled')">
        <font-awesome-icon icon="times" />
      </button>
    </div>

    <p v-if="error('contract_id') || error('order_id')" class="red">товар уже есть в списке позиций</p>

    <div class="fields mv3">
      <!--
      <horizontal-form-field required="true">
        <template #title>Наименование</template>
        <template #input><input class="text-input bg-middle" type="text" :value="editable.title" @input="changed('title', $event)"></template>
        <template #error>{{ error('title') }}</template>
      </horizontal-form-field>
      -->

      <span class="label input-label required">Наименование</span>
      <div>
        <textarea rows="3" class="horizontal-input-readonly" readonly v-model="editable.title"></textarea>
        <div class="red">{{ error('title') }}</div>
      </div>

      <span class="label input-label required">Артикул</span>
      <div>
        <input class="text-input bg-middle" type="text" :value="editable.vendor_code" @input="changed('vendor_code', $event)">
        <div class="red">{{ error('vendor_code') }}</div>
      </div>

      <span class="label input-label required">Единица измерения</span>
      <div>
        <search-select
          :options="$store.getters['dict/units']"
          v-model="posUnit"
          :search-enabled="true"
          bg="dark"
        ></search-select>
        <div class="red">{{ error('unit_id') }}</div>
      </div>

      <span class="label input-label required">Объем организатора</span>
      <div>
        <input class="text-input bg-middle" type="number" :value="editable.amount" @input="changed('amount', $event)">
        <div class="red">{{ error('amount') }}</div>
      </div>

      <span class="label input-label required">Цена организатора</span>
      <div>
        <input class="text-input bg-middle" type="number" :value="editable.price" @input="changed('price', $event)">
        <div class="red">{{ error('price') }}</div>
      </div>

      <span class="label input-label required">Cрок поставки в днях</span>
      <div>
        <input class="text-input bg-middle" type="number" :value="editable.delivery_within_days" @input="changed('delivery_within_days',  $event)">
        <div class="red">{{ error('delivery_within_days') }}</div>
      </div>

      <span class="label input-label required">Комментарий организатора</span>
      <div>
        <textarea rows="4" class="bg-middle" v-model="editable.anno"></textarea>
        <div class="red">{{ error('anno') }}</div>
      </div>

      <!--
      <div class="mt2 flex flex-column">
        <span class="db mb1 text-secondary">Ставка НДС %</span>
        <input class="text-input bg-middle" type="number" :value="editable.vat" @input="changed('vat', $event)">
        <span style="color: red">{{ error('vat') }}</span>
      </div>
      <div class="mt2 flex flex-column">
        <span class="db mb1 text-secondary">Валюта</span>
        <search-select
          :options="$store.getters['dict/currencies']"
          v-model="posCurrency"
          :search-enabled="true"
          :labelProvider="currencyLabel"
          bg="dark"
        ></search-select>
        <span style="color: red">{{ error('currency_id') }}</span>
      </div>
      -->
    </div>

    <div class="bt b--near-white pt3 flex justify-end">
      <action-button :title="actionBtnTitle" :loading="loading" @click="actionTriggered" class="ml3"/>
    </div>

  </div>
</template>

<script>
import SearchSelect from '@/components/ui/SearchSelect.vue'
import ActionButton from '@/components/ui/Button.vue'

export default {
  props: ['context'],
  components: {
    SearchSelect,
    ActionButton
  },
  data () {
    return {
      editable: { ...this.context.position },
      errors: null,
      unit: null,
      loading: false
    }
  },
  computed: {
    position () {
      return this.context.position
    },
    isCreateForm () {
      return this.context.mode === 'create'
    },
    actionBtnTitle () {
      return this.isCreateForm ? 'добавить' : 'сохранить'
    },
    posUnit: {
      get () {
        return this.$store.getters['dict/units'].findIndex(u => u.id === this.editable.unit_id)
      },
      set (idx) {
        this.editable.unit_id = Number.isInteger(idx) ? this.$store.getters['dict/units'][idx].id : null
      }
    },
    posCurrency: {
      get () {
        return this.$store.getters['dict/currencies'].findIndex(c => c.id === this.editable.currency_id)
      },
      set (idx) {
        this.editable.currency_id = Number.isInteger(idx) ? this.$store.getters['dict/currencies'][idx].id : null
      }
    }
  },
  methods: {
    changed (field, event) {
      // если в input пустое значние "", то соханяем вместо пустой строки null
      const value = field === 'delivery_within_days'
        ? +event.target.value
        : event.target.value
      this.$set(this.editable, field, value || null)
    },
    async actionTriggered () {
      if (this.loading) return
      this.loading = true
      this.context.callback(this.$lo.clone(this.editable))
        .then(({ position, errors }) => {
          if (errors) {
            this.errors = errors
          } else {
            this.errors = null
            this.editable = position
            this.$emit('submitted', { position, mode: this.context.mode })
          }
        })
        .catch((e) => {
          console.error(`[Position ${this.context.mode} error]: ${e}`)
        }).finally(() => {
          this.loading = false
        })
    },
    error (field) {
      const err = this.errors
        ? this.errors.find((e) => e.field === field)?.errors[0]
        : null
      return err
    },
    currencyLabel (c) {
      return c ? c.name + ' : ' + c.full_name : c
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
